export type ExtratoPeriodoPreset =
  | "hoje"
  | "7d"
  | "30d"
  | "mes"
  | "personalizado";

/** Formato `yyyy-MM-dd` em calendário local. */
export function formatarYmdLocalExtrato(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function inicioFimMesCorrenteLocalExtrato(): {
  dataInicio: string;
  dataFim: string;
} {
  const now = new Date();
  const ini = new Date(now.getFullYear(), now.getMonth(), 1);
  const fim = new Date(now.getFullYear(), now.getMonth() + 1, 0);
  return {
    dataInicio: formatarYmdLocalExtrato(ini),
    dataFim: formatarYmdLocalExtrato(fim),
  };
}

export function periodoExtratoParaDatas(
  preset: ExtratoPeriodoPreset,
): { dataInicio: string; dataFim: string } | null {
  const hoje = new Date();
  const ymd = formatarYmdLocalExtrato;

  switch (preset) {
    case "hoje": {
      const d = ymd(hoje);
      return { dataInicio: d, dataFim: d };
    }
    case "7d": {
      const ini = new Date(hoje);
      ini.setDate(ini.getDate() - 7);
      return { dataInicio: ymd(ini), dataFim: ymd(hoje) };
    }
    case "30d": {
      const ini = new Date(hoje);
      ini.setDate(ini.getDate() - 30);
      return { dataInicio: ymd(ini), dataFim: ymd(hoje) };
    }
    case "mes":
      return inicioFimMesCorrenteLocalExtrato();
    default:
      return null;
  }
}
